import React, { useState, useCallback } from "react";

// Move styles outside component to prevent recreation
const styles = {
  container: {
    border: "1px solid #ddd",
    borderRadius: "10px",
    marginBottom: "12px",
  },
  header: {
    padding: "12px 16px",
    background: "#f8f8f8",
    cursor: "pointer",
    fontWeight: "600",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
};

const CollapsibleSection = React.memo(
  function CollapsibleSection({
    title,
    children,
    defaultOpen = false,
    triggerClose,
  }) {
    const [open, setOpen] = useState(defaultOpen);

    // Memoize toggle function
    // const toggleOpen = useCallback(() => {
    //   setOpen((prev) => !prev);
    // }, []);

    // Compute content style based on open state
    const contentStyle = {
      maxHeight: open ? "2000px" : "0px",
      overflow: "hidden",
      transition: "max-height 0.35s ease",
      padding: open ? "16px" : "0px",
    };
    React.useEffect(() => {
      if (triggerClose) {
        setOpen(false);
      }
    }, [triggerClose]);

    return (
      <div style={styles.container}>
        <div onClick={() => setOpen((prev) => !prev)} style={styles.header}>
          {title}
          <span>{open ? "▲" : "▼"}</span>
        </div>

        <div style={contentStyle}>{children}</div>
      </div>
    );
  },
  // Custom comparison function - only re-render if title changes
  (prevProps, nextProps) => {
    return prevProps === nextProps;
  },
);

export default CollapsibleSection;